import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import styles from '../../styles/TMRWMember/1ChooseMember.module.css';

function FrameSelectionTMRWMember() {
  const navigate = useNavigate();
  const [selectedFrame, setSelectedFrame] = useState(null);

  const frameOptions = [
    { id: 'soobin', name: 'SOOBIN', frameImage: '/img/TMRWMember/SB.png', overlays: ['SB1.png','SB2.png','SB3.png','SB4.png'] },
    { id: 'yeonjun', name: 'YEONJUN', frameImage: '/img/TMRWMember/YJ.png', overlays: ['YJ1.png','YJ2.png','YJ3.png','YJ4.png'] },
    { id: 'beomgyu', name: 'BEOMGYU', frameImage: '/img/TMRWMember/BG.png', overlays: ['BG1.png','BG2.png','BG3.png','BG4.png'] },
    { id: 'taehyun', name: 'TAEHYUN', frameImage: '/img/TMRWMember/TH.png', overlays: ['TH1.png','TH2.png','TH3.png','TH4.png'] },
    { id: 'hueningkai', name: 'HUENINGKAI', frameImage: '/img/TMRWMember/HK.png', overlays: ['HK1.png','HK2.png','HK3.png','HK4.png'] }
  ];

  const handleFrameSelect = (frame) => setSelectedFrame(frame);

  const handleContinue = () => {
    if (selectedFrame) {
      navigate('/photobooth/TMRWMember', { 
        state: { 
          selectedFrame,
          frameImage: selectedFrame.frameImage,
          overlays: selectedFrame.overlays
        }
      });
    }
  };

  return (
    <div className={styles['frame-selection-container']}>
      <Link to="/" className={styles['frame-back-link']}>
        ← Back to Home
      </Link>

      <h2 className={styles['frame-selection-title']}>
        Please choose a frame
      </h2>

      <div className={styles['frame-selection-grid']}>
        {frameOptions.map((frame) => (
          <div key={frame.id} className={styles['frame-container']}>
            <div 
              className={`${styles['frame-option']} ${selectedFrame?.id === frame.id ? styles['selected'] : ''}`}
              onClick={() => handleFrameSelect(frame)}
            >
              <div className={styles['frame-image-container']}>
                <img
                  src={frame.frameImage}
                  alt={frame.name}
                  className={styles['frame-image']}
                  onError={(e) => {
                    console.error(`Failed to load image: ${frame.frameImage}`);
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'flex';
                  }}
                />
                <div className={styles['frame-fallback']} style={{ display: 'none' }}>
                  {frame.name}
                </div>
              </div>
            </div>
            <div className={styles['frame-name']}>{frame.name}</div>
          </div>
        ))}
      </div>

      <div className={styles['frame-continue-section']}>
        <button
          onClick={handleContinue}
          disabled={!selectedFrame}
          className={styles['frame-continue-button']}
        >
          Next &gt;
        </button>
      </div>
    </div>
  );
}

export default FrameSelectionTMRWMember;
